<template>
  <div class="toggle" @click="select">
    <div class="row">
      <div class="col-xs-12">
        <div v-if="fieldNote.show" :class="fieldNote.class">
          <i>
            {{ fieldNote.tooltip }}
          </i>
        </div>
        <c-checkbox :value="checked"
                    type="reaInfADI"
                    size="sm"
                    @input="toggle"
                    block>
          <div>
            <div class="toggle-selected-title" v-if="selected">
              {{ config.title }}
            </div>
            <div class="toggle-title" v-else>
              {{ config.title }}
            </div>
          </div>
        </c-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import checkbox from '@/sui/components/checkbox'
import noteImpl from '@/sui/components/sheet/add/impl/notes'

export default {
  name: 'toggle',
  props: {
    selected: {
      type: Boolean,
      required: true
    },

    value: {
      type: Boolean
    },

    note: {
      type: Object
    },

    parameters: {
      type: Object
    }
  },

  computed: {
    checked: function () {
      return this.value == null ? false : this.value
    },

    config: function () {
      if (this.parameters != null) {
        return this.parameters.config.config
      }

      return null
    },

    fieldNote: function () {
      return noteImpl.getNote(this.note)
    }
  },

  methods: {
    toggle: function (value) {
      if (this.checked !== value) {
        this.$emit('commit', value)
      }
    },

    select: function () {
      if (!this.selected) {
        this.$emit('select')
      }
    }
  },

  mounted: function () {
  },

  components: {
    'c-checkbox': checkbox
  }
}

</script>
<style scoped lang="less">
@import '~variables';

.toggle-title {
  font-size: 14px;
}

.toggle-selected-title {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
